import { render, staticRenderFns } from "./PriceguardTimeElapsed.vue?vue&type=template&id=24aadfd3"
import script from "./PriceguardTimeElapsed.vue?vue&type=script&lang=js"
export * from "./PriceguardTimeElapsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24aadfd3')) {
      api.createRecord('24aadfd3', component.options)
    } else {
      api.reload('24aadfd3', component.options)
    }
    module.hot.accept("./PriceguardTimeElapsed.vue?vue&type=template&id=24aadfd3", function () {
      api.rerender('24aadfd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceguardTimeElapsed.vue"
export default component.exports